import { entities } from "sb-resp-lib";
import { selectionsOrdering } from "../../constants";
import { MarketTemplate } from "../../data";

export const findSelectionsOrdering = (template: MarketTemplate, outcomeType: entities.OutcomeType | null): string => {
    let orderMap = selectionsOrdering[template];
    return outcomeType && Object.keys(orderMap).filter(
        key => {
            return orderMap[key].find(val => {
                return val === outcomeType && key
            });
        }
    ).shift() || "0";
}